import React from 'react';

export const WithTooltip = ({ tooltip, disabledTooltip, disabled, children, position = 'bottom' }) => {
  const elements = React.Children.map(children, child => React.cloneElement(child, { disabled }));

  const title = tooltip || disabledTooltip ? (disabled ? disabledTooltip : tooltip) : null;
  //<MuiTooltip is incredibly slow with moderate numbers of rows.
  return !title ? (
    <>{elements}</>
  ) : (
    <span data-tooltip={title} data-position={position}>
      <span>{elements}</span>
    </span>
  );
};
